import {applyMiddleware, combineReducers, compose, createStore} from 'redux'
import thunk from 'redux-thunk';
import {connectRouter, routerMiddleware} from 'connected-react-router'
import promiseMiddleware from './middleware/simple-promise';

import * as reducers from './modules'

export default (history) => {
  const appReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = composeEnhancers(applyMiddleware(thunk, promiseMiddleware(), routerMiddleware(history)));
  return createStore(appReducer, {}, middlewares);
}
